/**
 * @desc 详情
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.storageDamageMaster.detail.Params, options?: any) {
  return updateResponse(
    http(URL + `/storageDamageMaster/detail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
